(function(){
  function init(){
    var section=document.querySelector('[data-collection-section]');
    if(!section||section.dataset.infiniteReady==='true') return;
    var grid=section.querySelector('[data-collection-grid]');
    var root=section.querySelector('[data-infinite-root]');
    if(!grid||!root) return;
    section.dataset.infiniteReady='true';
    var button=root.querySelector('[data-load-more]');
    var status=root.querySelector('[data-load-status]');
    var fallback=section.querySelector('[data-pagination-fallback]');
    var loading=false;
    if(fallback) fallback.hidden=true;

    function newFirst(container){
      var firstRegular=container.querySelector('[data-product-card]:not([data-product-new])');
      Array.prototype.slice.call(container.querySelectorAll('[data-product-new]')).forEach(function(card){
        if(firstRegular&&card.compareDocumentPosition(firstRegular)&Node.DOCUMENT_POSITION_PRECEDING){ container.insertBefore(card,firstRegular); }
      });
    }
    function setDone(){ root.classList.add('is-done'); if(observer) observer.disconnect(); }
    function load(){
      var next=root.getAttribute('data-next-url');
      if(loading||!next){ setDone(); return; }
      loading=true;
      if(button) button.hidden=true;
      if(status) status.hidden=false;
      fetch(next,{headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(response){ if(!response.ok) throw new Error('Collection page failed'); return response.text(); })
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var nextGrid=doc.querySelector('[data-collection-grid]');
          var nextRoot=doc.querySelector('[data-infinite-root]');
          if(nextGrid){ Array.prototype.slice.call(nextGrid.children).forEach(function(card){ grid.appendChild(card); }); newFirst(grid); }
          var following=nextRoot?nextRoot.getAttribute('data-next-url'):'';
          root.setAttribute('data-next-url',following||'');
          if(!following) setDone();
        })
        .catch(function(){ if(button){ button.hidden=false; button.textContent='Try loading again'; } })
        .then(function(){ loading=false; if(status) status.hidden=true; if(button&&!root.classList.contains('is-done')) button.hidden=false; });
    }
    if(button) button.addEventListener('click',load);
    var observer=null;
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(function(entries){ if(entries[0].isIntersecting) load(); },{rootMargin:'500px 0px'});
      observer.observe(root);
    } else if(button){
      button.hidden=false;
    }
    newFirst(grid);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
